import { Language } from './Language';

export class fr implements Language{

    //----------Connect----------//
    //UserActions
    UserActionsRef = "Référence";
    UserActionsDateSend = "Date d'émission";
    UserActionsDateDownload = "Date de téléchargement";
    UserActionsObservation = "Observation";
    UserActionsName = "Nom";
    UserActionsID = "Indice";
    UserActionsStatus = "Statut";
    UserActionsComment = "Commentaire";
    //Login
    LoginWelcome = "Bienvenue sur le portail Fives";
    LoginMailValid = "Email valide requis";
    LoginMailRequired = "Identifiant email requis";
    LoginPasswordRequired = "Mot de passe requis";
    LoginTitle = "Portail documentaire";
    LoginID = "Identifiant";
    LoginPassword = "Mot de passe";
    LoginConnect = "Se connecter";

    //----------Components----------//
    //BoxModule
    BoxModuleLoad = "Chargement...";
    BoxModuleAlt = "logo du module";
    BoxModuleSingular = "document";
    BoxModulePlural = "documents";
    //DisplayDocs
    DisplayDocsName = "nom";
    DisplayDocsCreation = "date de création"
    DisplayDocsRecipient = "destinataire";
    DisplayDocsAuthor = "auteur";
    DisplayDocsContract = "contrat";
    //ExternalDocModal
    ExternalDocModalReceive = "Réceptionner";
    //MyModal
    MyModalApproved = "Approuvé";
    MyModalApprovedWithComment = "Approuvé avec commentaires";
    MyModalReceiveTitle = "Envoi d'un commentaire de réception";
    MyModalReceiveWarning = "Attention, en approuvant/refusant cette collection,";
    MyModalReceiveWarning2 = "vous approuvez/refusez tous les documents qu'elle contient";
    MyModalComments = "Commentaire(s)";
    MyModalInProgress = "En cours ";
    MyModalApprove = "Approuver";
    MyModalApproveComment = "Approuver avec commentaire";
    MyModalReject = "Refuser";
    MyModalCancel = "Annuler";
    MyModalExternalInProgress = "En cours ";
    MyModalExternalApprove = "Approuver";
    MyModalExternalApproveComment = "Approuver avec commentaire";
    MyModalExternalReject = "Refuser";
    MyModalExternalCancel = "Annuler";
    MyModalReceivedTitle = "Retour client";
    MyModalReceivedStatus = "Statut Client :";
    MyModalReceivedDate = "Date du retour :";
    MyModalReceivedRole = "Retour effectué par :";
    MyModalReceivedComments = "Commentaire(s)";
    MyModalReceivedClose = "Fermer";
    MyModalReceivedRefused = "Refusé";
    MyModalFile = "Séléct. Fichiers";
    MyModalFileEmpty = "Aucun fichier choisi";
    MyModalFileSingular = "fichier";
    MyModalFilePlural = "fichiers";
    //RecepModal
    RecepModalReceive = "Réceptionner";
    //SendNewDocModal
    SendNewDocModalModify = "Modifier";
    SendNewDocModalSend = "Envoyer un nouveau document";
    //ExpandedDataTable
    ExpandedDataTableTitle = "Mes documents : "
    ExpandedDataTableNoDocument = "Aucun document";
    //MyDataTable
    MyDataTableProgress = "En cours ";
    MyDataTableReceived = "Réceptionnée";
    MyDataTableDownloading = "Téléchargement en cours ";
    MyDataTableDownload = "Télécharger";
    MyDataTableNoData = "Aucune donnée correspondante";
    MyDataTableSelected = "collection sélectionnée";
    MyDataTableSelectedPlural = "collections sélectionnées";
    MyDataTableSeparator = "de";
    //Navbar
    NavbarHomepage = "Accueil";
    NavbarReceive = "Réception de documents";
    NavbarSending = "Envoi de documents";
    NavbarExternal = "Documents externes";
    NavbarPolicy = "Politique Fives";
    NavbarDisconnect = "Se déconnecter";
    NavbarFirst = "Première connexion : définir un nouveau mot de passe";
    //Report
    ReportTitle = "@2022 - Fives - Portail Documentaire";
    ReportProblem = "Signaler un problème";

    //----------Pages----------//
    //ExternalDocs
    ExternalDocsTitle = "Documents externes";
    ExternalDocsLoad = "Chargement des documents en cours...";
    //Home
    HomeSee = "Voir";
    HomeReceiveName = "Réception de documents";
    HomeReceiveDesc = "Diffusions à télécharger";
    HomeSendName = "Envoi de documents";
    HomeSendDesc = "Nouvelle(s) diffusion(s) de document(s)";
    HomeAccountName = "Mon compte";
    HomeAccountDesc = "Mettre à jour mon mot de passe";
    HomePolicyName = "Politique Fives";
    HomePolicyDesc = "Politique relative aux données personnelles";
    //ModifyPassword
    ModifyPasswordActual = "Mot de passe actuel";
    ModifyPasswordActualText = "Saisissez votre mot de passe actuel";
    ModifyPasswordNew = "Nouveau mot de passe";
    ModifyPasswordNewText = "Saisissez votre nouveau mot de passe";
    ModifyPasswordConfirm = "Confirmer";
    ModifyPasswordConfirmText = "Ressaisissez votre nouveau mot de passe";
    ModifyPasswordErrorDiff = "Les deux mots de passe sont différents";
    ModifyPasswordErrorInvalid = "Le mot de passe doit contenir au moins ";
    ModifyPasswordErrorInvalid2 = " caractères, une minuscule, une majuscule, un chiffre et un caractère spécial";
    ModifyPasswordErrorIncorrect = "Mot de passe actuel incorrect";
    ModifyPasswordSuccess = "Mot de passe modifié avec succès";
    //MyAccount
    MyAccountChange = "Changer mon mot de passe";
    //RecepDocs
    RecepDocsRecipient = "Destinataire : ";
    RecepDocsContracts = "Contrats";
    RecepDocsContractsAll = "Tous";
    RecepDocsContractsUpToDate = "Contrats à jour";
    RecepDocsContractsLoad = "Chargement des derniers contrats en cours...";
    RecepDocsCollection = "Mes collections";
    RecepDocsCollectionUpToDate = "Collections à jour";
    RecepDocsCollectionLoad = "Chargement des dernières collections en cours...";
    RecepDocsCollectionLoad2 = "Chargement des collections en cours";
    RecepDocsShow = "Afficher";
    RecepDocsShowAll = "Toutes les collections";
    RecepDocsShowUndownloaded = "Non téléchargées";
    RecepDocsShowRadio = "N'afficher que les collections dont les documents ne sont pas tous réceptionnés";
    RecepDocsSearch = "Rechercher";
    RecepDocsRefresh = "Rafraichir";
    //HeaderSendDocs
    HeaderSendDocsSender = "Expéditeur : "; 
    HeaderSendDocsInfo = "Informations";
    //MyBroadcasts
    MyBroadcastsInternalID = "ID interne";
    MyBroadcastsName = "Nom du fichier";
    MyBroadcastsID = "Indice";
    MyBroadcastsStatus = "Statut";
    MyBroadcastsComment = "Commentaire";
    MyBroadcastsShow = "Voir les documents archivés";
    MyBroadcastsSearch = "Faire une recherche...";
    MyBroadcastsLoad = "Chargement de tous les documents en cours...";
    MyBroadcastsLoad2 = "Chargement des documents en cours...";
    MyBroadcastsRefresh = "Rafraîchir";
    MyBroadcastsTitle = "Documents envoyés";
    //SendNewDoc
    SendNewDocModified = "Document modifié avec succès";
    SendNewDocSent = "Document envoyé avec succès";
    SendNewDocError = "Document invalide, vérifiez l'extension du fichier (extensions valides : pdf, xlsx, xls)";
    SendNewDocModifying = "Modification en cours ";
    SendNewDocSending = "Envoi en cours ";
    SendNewDocModify = "Modifier";
    SendNewDocSend = "Envoyer un nouveau document";
    SendNewDocNotSupported = "Type de données non pris en charge";
    SendNewDocIndex = "Indice";
    SendNewDocStatus = "Statut";
    SendNewDocComment = "Commentaire";
    SendNewDocFile = "Séléct. Fichiers";
    SendNewDocFileEmpty = "Aucun fichier choisi";
    SendNewDocFileSingular = "fichier";
    SendNewDocFilePlural = "fichiers";
    //SwitchPage
    SwitchPagePassword = "Changer mon mot de passe";
    SwitchPageDisconnect = "Se déconnecter";

    //----------Public----------//
    //AuthentificationChoice
    AuthentificationChoiceMail = "Recevoir un mail";
    AuthentificationChoiceSMS = "Recevoir un SMS";
    //EnterMail
    EnterMailError = "Erreur lors de l'envoi. Le lien utilisé pour accéder à la page a peut-être expiré.";
    EnterMailAddress = "Saisissez votre adresse mail";
    EnterMailSend = "Envoyer";
    EnterMailBack = "Retour";
    //MyTimer
    MyTimerExpired = "Le code a expiré";
    //Public
    PublicQuestion = "Comment voulez-vous recevoir votre code temporaire ?";
    //PublicDatatableCollections
    PublicDatatableCollectionsRef = "Référence";
    PublicDatatableCollectionsDateSend = "Date d'émission";
    PublicDatatableCollectionsDateDownload = "Date de téléchargement";
    PublicDatatableCollectionsObservation = "Observation";
    PublicDatatableCollectionsSearch = "Rechercher";
    PublicDatatableCollectionsTitle = "Mes collections";
    //SendingCode
    SendingCodeInProgress = "Envoi du ";
    SendingCodeInProgress2 = " en cours ";
    //SuccessDownload
    SuccessDownloadSuccess = "Téléchargement réussi";
    SuccessDownloadBack = "Revenir à l'accueil";
    //WaitingForCode
    WaitingForCodeSent = "Si l'adresse mail saisie existe, un mail lui a été envoyé.";
    WaitingForCodeTimer = "Vous avez dix minutes pour entrer le code reçu par ";
    WaitingForCodeChecking = "Vérification du code en cours...";
    WaitingForCodeError = "Code invalide, expiré ou déjà utilisé";
    WaitingForCodeCheck = "Vérifier";
    WaitingForCodeBack = "Retour";

    //----------WebApi----------//
    //WebApi
    WebApiErrorBadRequest = "Mauvaise requête";
    WebApiErrorRights = "Vous n'avez pas les permissions d'envoyer un document";
    WebApiErrorInvalid = "Document invalide, vérifiez l'extension du fichier (extensions valides : pdf, xlsx)";

    //RecoilApp
    RecoilAppConnection = "Vérification de la connexion en cours...";
}